import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkles, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function ProGate({ title, description, children }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (user?.is_pro) return children;

  return (
    <div className="relative">
      <div className="pointer-events-none select-none blur-[6px] opacity-40 max-h-[60vh] overflow-hidden">
        {children}
      </div>
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        className="absolute inset-0 flex items-start justify-center pt-16"
      >
        <div className="tcc-card p-8 max-w-md text-center bg-gradient-to-br from-primary/12 via-white to-accent/20" data-testid="pro-gate">
          <div className="h-14 w-14 mx-auto rounded-2xl bg-primary/15 flex items-center justify-center mb-4">
            <Lock className="text-primary" strokeWidth={1.7} />
          </div>
          <h2 className="font-heading text-2xl font-extrabold text-slate-800">{title}</h2>
          <p className="text-slate-500 mt-2 mb-6">{description}</p>
          <Button onClick={() => navigate("/pricing")} data-testid="pro-gate-upgrade" className="rounded-full bg-primary hover:bg-primary/90 h-11 px-7">
            <Sparkles size={17} className="mr-1.5" /> Upgrade to Pro
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
